import { Component, OnInit, Input, ViewChild, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { LOCAL_STORAGE_CONSTANT } from 'src/app/core/services/local-storage.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-package-playlist-list',
  templateUrl: './package-playlist-list.component.html',
  styleUrls: ['./package-playlist-list.component.scss']
})
export class PackagePlaylistListComponent implements OnInit {

  @Input() public activeTab;
  @Input() public content;
  @Input() public type;
  @Input() public totalContent;
  @Input() public p;
  @Output() paginateSeach = new EventEmitter();
  @Output() changeTab = new EventEmitter();
  totalCount = 0;
  recordsPerPage = 15;
  imgURL = API_ENDPOINTS.BASE_URL;
  userData;
  package = [];
  playlist = [];
  @ViewChild('owlCarousel1', { static: false }) owlCarousel1: any;
  @ViewChild('owlCarousel2', { static: false }) owlCarousel2: any;
  customOptions1: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    margin: 0,
    autoWidth: true,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 5
      }
    },
    nav: true
  }
  customOptions2: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    margin: 0,
    autoWidth: true,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 5
      }
    },
    nav: true
  }
  constructor(
    private _localStorageService: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    // if(this.content && this.content.length > 0){
    //   this.content.forEach(element => {
    //     if(element.collection_type == 'normal'){
    //       this.playlist.push(element);
    //     }else if(element.collection_type == 'special'){
    //       this.package.push(element)
    //     }
    //   });
    // }
    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.package = [];
    this.playlist = [];
    if (changes.content && changes.content.currentValue && changes.content.currentValue.length > 0) {
      // changes.content.currentValue.forEach(element => {
      //   if(element.collection_type == 'normal'){
      //     this.playlist.push(element);
      //   }else if(element.collection_type == 'special'){
      //     this.package.push(element)
      //   }
      // });
      if (this.type == 'playlist') {
        this.playlist = changes.content.currentValue;
        if (this.playlist) {
          this.playlist.forEach(playlist => {
            if (playlist.contents) {
              playlist.contents.every((element) => {
                if ((element.visibility == 'grayed' && this.userData && this.userData.user.id !== element.user_id && element.tokens <= 0) || (this.userData && this.userData.user.id !== element.user_id && element.content_relationship && element.content_relationship.visibility == 'disable')) {
                  playlist.thumbnail_grayed = (element.content_type == 'audio') ? '/assets/images/deleted-audio.svg' : (element.content_type == 'video' ? '/assets/images/deleted-video.svg' : '/assets/images/deleted-publication.svg')
                } else {
                  playlist.thumbnail = element.thumb;
                  playlist.thumbnail_grayed = null;
                  return false;
                }
                return true;
              });
            }
          });
        }
      } else {
        this.package = changes.content.currentValue;
        if (this.package) {
          this.package.forEach(playlist => {
            if (playlist.contents) {
              playlist.contents.every((element) => {
                if ((element.visibility == 'grayed' && this.userData && this.userData.user.id !== element.user_id && element.tokens <= 0) || (this.userData && this.userData.user.id !== element.user_id && element.content_relationship && element.content_relationship.visibility == 'disable')) {
                  playlist.thumbnail_grayed = (element.content_type == 'audio') ? '/assets/images/deleted-audio.svg' : (element.content_type == 'video' ? '/assets/images/deleted-video.svg' : '/assets/images/deleted-publication.svg')
                } else {
                  playlist.thumbnail = element.thumb;
                  playlist.thumbnail_grayed = null;
                  return false;
                }
                return true;
              });
            }
          });
        }
      }
    }

    if (this.package.length > 0 && this.package.length < 6) {
      this.customOptions1.responsive['1199'].items = this.package.length;
      this.customOptions1.loop = false;
    } else if (this.package.length >= 6) {
      this.customOptions1.loop = true;
      this.customOptions1.responsive['1199'].items = 5;
    }
    if (this.playlist.length > 0 && this.playlist.length < 6) {
      this.customOptions2.responsive['1199'].items = this.playlist.length;
      this.customOptions2.loop = false;
    } else if (this.playlist.length >= 6) {
      this.customOptions2.loop = true;
      this.customOptions2.responsive['1199'].items = 5;
    }
  }
  navigateTo(id) {
    if (id)
      this.router.navigate(['/collection', id])
  }

  paginateTransactions(event) {
    this.p = event;
    this.paginateSeach.emit(this.p);
  }

  toggleView(view) {
    this.changeTab.emit(view);
  }
}
